/* eslint-disable no-underscore-dangle */
import * as React from "react";

import { graphql } from "gatsby";

import Text from "cms/components/Text";
import { Container, Content, QAContainer } from "./FaqBlock.styles";
import FaqItem from "./components/FaqItem.component";

export interface FaqBlockProps extends Partial<Queries.SanityFaqBlock> {}

const FaqBlock: React.FC<FaqBlockProps> = ({ headline, faqItems }) => (
  <Container>
    <Content>
      <Text variant="H3" as="h3" marginBottom="1.5rem">
        {headline}
      </Text>
      {faqItems?.map((faqItem) => {
        if (!faqItem) return null;

        return (
          <QAContainer key={faqItem.question}>
            <FaqItem
              question={faqItem.question}
              answer={faqItem._rawAnswer}
              button={faqItem.button}
            />
          </QAContainer>
        );
      })}
    </Content>
  </Container>
);

export const query = graphql`
  fragment FaqBlock on SanityFaqBlock {
    _key
    _type
    headline
    faqItems {
      question
      _rawAnswer(resolveReferences: { maxDepth: 5 })
      button {
        variant
        label
        url
      }
    }
  }
`;

export default FaqBlock;
